export const anetaStawiszynskaBiarda = {
    'meta': {
        'title': 'Psycholog, trenerka TUS Aneta Stawiszyńska-Biarda • COLLIGO',
        'description': 'Ukończyłam studia z psychologii na UMK w Toruniu. Odbywałam praktyki w Wojewódzkim Szpitalu Zespolonym na Oddziale Klinicznym Psychiatrii Młodzieży w Toruniu.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-aneta-stawiszynska-biarda/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/aneta-stawiszynska-biarda.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Toruniu Aneta Stawiszyńska-Biarda'
        }
    }
}